import { TraceRendererOptions, TraceRenderStrategy } from "./RenderStrategy"
import { LineRenderStrategy } from "./D3LineRenderStrategy"
import { curveStepAfter } from "d3"

export class LineStepRenderStrategy extends LineRenderStrategy implements TraceRenderStrategy {
    public getDirectRenderer = (options?: TraceRendererOptions) => {
        if (options?.xScale) {
            this.directRenderer.xScale(options.xScale)
        }

        if (options?.yScale) {
            this.directRenderer.yScale(options.yScale)
        }

        return this.directRenderer
            .mainValue((p: [number, number]) => p[1])
            .crossValue((p: [number, number]) => p[0])
            .curve(curveStepAfter)
            .decorate((context: CanvasRenderingContext2D) => {
                context.strokeStyle = this.config.color
                context.lineWidth = this.getLineWidth()
            })
    }

    public getOffscreenRenderer = (options?: TraceRendererOptions) => {
        if (options?.xScale) {
            this.offscreenRenderer.xScale(options.xScale)
        }

        if (options?.yScale) {
            this.offscreenRenderer.yScale(options.yScale)
        }

        return this.offscreenRenderer
            .mainValue((p: [number, number]) => p[1])
            .crossValue((p: [number, number]) => p[0])
            .curve(curveStepAfter)
            .decorate((context: CanvasRenderingContext2D) => {
                context.strokeStyle = this.config.color
                context.lineWidth = this.getLineWidth()
            })
    }
}
